import { taxInfoStatus, taxFormSubmission } from '../models/status';
export const isTaxInfoStatusCompleted = (status) => status === taxInfoStatus.Enum.completed;
export const isTaxInfoStatusArchived = (status) => status === taxInfoStatus.Enum.archived;
export const isTaxInfoStatusNoInfo = (status) => status === taxInfoStatus.Enum.no_info;
export const isTaxInfoStatusExpired = (status) => status === taxInfoStatus.Enum.expired;
export const isTaxInfoStatusRequested = (status) => status === taxInfoStatus.Enum.requested;
export const isTaxFormSubmissionInternal = (formSubmission) => formSubmission === taxFormSubmission.Enum.internal;
